module.exports = __webpack_public_path__ + "static/img/234.77fbda1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/200518/234.jpg
// module id = i6sN
// module chunks = 0